webpackJsonp([6],{

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// 返回在vue模板中的调用接口
/* harmony default export */ __webpack_exports__["a"] = ({
  baseUrl: "http://localhost:46666"
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(609);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', redirect: '/login' }, { path: '/index', redirect: '/index/dailyBill' }, { path: '/index', component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(653)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [
    //{ path: 'home', component: resolve => require(['./components/home.vue'], resolve) },
    //{ path: 'income', component: resolve => require(['./components/income.vue'], resolve) },
    //{ path: 'expend', component: resolve => require(['./components/expend.vue'], resolve) },
    { path: 'dailyBill', component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(652)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } }, { path: 'account', component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(651)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      } }]
  }, { path: '/login', component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(654)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }, { path: '/register', component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(655)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    } }]
}));

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(97);
/**
 * Created by Jerry on 2017/7/3.
 */



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  // 定义状态
  state: {
    activeIndex: '/login'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(325)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_store__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_bootstrap_min_css__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_font_awesome_min_css__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_reset_css__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_public_css__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_public_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_css_public_css__);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_8_axios___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.config = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_7_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_9_moment___default.a;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* default */]);

//导航守卫
__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {

  if (to.path !== '/login' && to.path !== '/register' && !isAuth()) {

    __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default()({
      message: "请先登录",
      type: 'error',
      duration: 3 * 1000
    });
    console.log(to.path);
    next('/login?redirect=' + to.path);
  } else {

    next();
  }
});

function isAuth() {

  var token = localStorage.token;
  return token !== undefined && token !== null;
}

// http请求拦截器
__WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.request.use(function (config) {

  if (localStorage.token) {
    config.headers["Authorization"] = "Bearer " + localStorage.token;
  }
  return config;
});
// http响应拦截器
__WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.response.use(function (response) {

  var res = response.data;
  if (res.code !== "10000") {

    __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default()({
      message: res.message || 'Error',
      type: 'error',
      duration: 3 * 1000
      //offset: 200
    });

    return Promise.reject(new Error(res.message || 'Error'));
  } else {
    return res.data;
  }
}, function (error) {
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_message___default()({
    message: '网络异常，请稍后重试',
    type: 'error',
    duration: 3 * 1000
  });
  return Promise.reject(error);
});

new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_11__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 158,
	"./af.js": 158,
	"./ar": 165,
	"./ar-dz": 159,
	"./ar-dz.js": 159,
	"./ar-kw": 160,
	"./ar-kw.js": 160,
	"./ar-ly": 161,
	"./ar-ly.js": 161,
	"./ar-ma": 162,
	"./ar-ma.js": 162,
	"./ar-sa": 163,
	"./ar-sa.js": 163,
	"./ar-tn": 164,
	"./ar-tn.js": 164,
	"./ar.js": 165,
	"./az": 166,
	"./az.js": 166,
	"./be": 167,
	"./be.js": 167,
	"./bg": 168,
	"./bg.js": 168,
	"./bm": 169,
	"./bm.js": 169,
	"./bn": 171,
	"./bn-bd": 170,
	"./bn-bd.js": 170,
	"./bn.js": 171,
	"./bo": 172,
	"./bo.js": 172,
	"./br": 173,
	"./br.js": 173,
	"./bs": 174,
	"./bs.js": 174,
	"./ca": 175,
	"./ca.js": 175,
	"./cs": 176,
	"./cs.js": 176,
	"./cv": 177,
	"./cv.js": 177,
	"./cy": 178,
	"./cy.js": 178,
	"./da": 179,
	"./da.js": 179,
	"./de": 182,
	"./de-at": 180,
	"./de-at.js": 180,
	"./de-ch": 181,
	"./de-ch.js": 181,
	"./de.js": 182,
	"./dv": 183,
	"./dv.js": 183,
	"./el": 184,
	"./el.js": 184,
	"./en-au": 185,
	"./en-au.js": 185,
	"./en-ca": 186,
	"./en-ca.js": 186,
	"./en-gb": 187,
	"./en-gb.js": 187,
	"./en-ie": 188,
	"./en-ie.js": 188,
	"./en-il": 189,
	"./en-il.js": 189,
	"./en-in": 190,
	"./en-in.js": 190,
	"./en-nz": 191,
	"./en-nz.js": 191,
	"./en-sg": 192,
	"./en-sg.js": 192,
	"./eo": 193,
	"./eo.js": 193,
	"./es": 197,
	"./es-do": 194,
	"./es-do.js": 194,
	"./es-mx": 195,
	"./es-mx.js": 195,
	"./es-us": 196,
	"./es-us.js": 196,
	"./es.js": 197,
	"./et": 198,
	"./et.js": 198,
	"./eu": 199,
	"./eu.js": 199,
	"./fa": 200,
	"./fa.js": 200,
	"./fi": 201,
	"./fi.js": 201,
	"./fil": 202,
	"./fil.js": 202,
	"./fo": 203,
	"./fo.js": 203,
	"./fr": 206,
	"./fr-ca": 204,
	"./fr-ca.js": 204,
	"./fr-ch": 205,
	"./fr-ch.js": 205,
	"./fr.js": 206,
	"./fy": 207,
	"./fy.js": 207,
	"./ga": 208,
	"./ga.js": 208,
	"./gd": 209,
	"./gd.js": 209,
	"./gl": 210,
	"./gl.js": 210,
	"./gom-deva": 211,
	"./gom-deva.js": 211,
	"./gom-latn": 212,
	"./gom-latn.js": 212,
	"./gu": 213,
	"./gu.js": 213,
	"./he": 214,
	"./he.js": 214,
	"./hi": 215,
	"./hi.js": 215,
	"./hr": 216,
	"./hr.js": 216,
	"./hu": 217,
	"./hu.js": 217,
	"./hy-am": 218,
	"./hy-am.js": 218,
	"./id": 219,
	"./id.js": 219,
	"./is": 220,
	"./is.js": 220,
	"./it": 222,
	"./it-ch": 221,
	"./it-ch.js": 221,
	"./it.js": 222,
	"./ja": 223,
	"./ja.js": 223,
	"./jv": 224,
	"./jv.js": 224,
	"./ka": 225,
	"./ka.js": 225,
	"./kk": 226,
	"./kk.js": 226,
	"./km": 227,
	"./km.js": 227,
	"./kn": 228,
	"./kn.js": 228,
	"./ko": 229,
	"./ko.js": 229,
	"./ku": 230,
	"./ku.js": 230,
	"./ky": 231,
	"./ky.js": 231,
	"./lb": 232,
	"./lb.js": 232,
	"./lo": 233,
	"./lo.js": 233,
	"./lt": 234,
	"./lt.js": 234,
	"./lv": 235,
	"./lv.js": 235,
	"./me": 236,
	"./me.js": 236,
	"./mi": 237,
	"./mi.js": 237,
	"./mk": 238,
	"./mk.js": 238,
	"./ml": 239,
	"./ml.js": 239,
	"./mn": 240,
	"./mn.js": 240,
	"./mr": 241,
	"./mr.js": 241,
	"./ms": 243,
	"./ms-my": 242,
	"./ms-my.js": 242,
	"./ms.js": 243,
	"./mt": 244,
	"./mt.js": 244,
	"./my": 245,
	"./my.js": 245,
	"./nb": 246,
	"./nb.js": 246,
	"./ne": 247,
	"./ne.js": 247,
	"./nl": 249,
	"./nl-be": 248,
	"./nl-be.js": 248,
	"./nl.js": 249,
	"./nn": 250,
	"./nn.js": 250,
	"./oc-lnc": 251,
	"./oc-lnc.js": 251,
	"./pa-in": 252,
	"./pa-in.js": 252,
	"./pl": 253,
	"./pl.js": 253,
	"./pt": 255,
	"./pt-br": 254,
	"./pt-br.js": 254,
	"./pt.js": 255,
	"./ro": 256,
	"./ro.js": 256,
	"./ru": 257,
	"./ru.js": 257,
	"./sd": 258,
	"./sd.js": 258,
	"./se": 259,
	"./se.js": 259,
	"./si": 260,
	"./si.js": 260,
	"./sk": 261,
	"./sk.js": 261,
	"./sl": 262,
	"./sl.js": 262,
	"./sq": 263,
	"./sq.js": 263,
	"./sr": 265,
	"./sr-cyrl": 264,
	"./sr-cyrl.js": 264,
	"./sr.js": 265,
	"./ss": 266,
	"./ss.js": 266,
	"./sv": 267,
	"./sv.js": 267,
	"./sw": 268,
	"./sw.js": 268,
	"./ta": 269,
	"./ta.js": 269,
	"./te": 270,
	"./te.js": 270,
	"./tet": 271,
	"./tet.js": 271,
	"./tg": 272,
	"./tg.js": 272,
	"./th": 273,
	"./th.js": 273,
	"./tk": 274,
	"./tk.js": 274,
	"./tl-ph": 275,
	"./tl-ph.js": 275,
	"./tlh": 276,
	"./tlh.js": 276,
	"./tr": 277,
	"./tr.js": 277,
	"./tzl": 278,
	"./tzl.js": 278,
	"./tzm": 280,
	"./tzm-latn": 279,
	"./tzm-latn.js": 279,
	"./tzm.js": 280,
	"./ug-cn": 281,
	"./ug-cn.js": 281,
	"./uk": 282,
	"./uk.js": 282,
	"./ur": 283,
	"./ur.js": 283,
	"./uz": 285,
	"./uz-latn": 284,
	"./uz-latn.js": 284,
	"./uz.js": 285,
	"./vi": 286,
	"./vi.js": 286,
	"./x-pseudo": 287,
	"./x-pseudo.js": 287,
	"./yo": 288,
	"./yo.js": 288,
	"./zh-cn": 289,
	"./zh-cn.js": 289,
	"./zh-hk": 290,
	"./zh-hk.js": 290,
	"./zh-mo": 291,
	"./zh-mo.js": 291,
	"./zh-tw": 292,
	"./zh-tw.js": 292
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 605;

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[344]);


// WEBPACK FOOTER //
// static/js/app.4eb82f086c1cef445421.js